module.exports = __webpack_public_path__ + "img/caratula.7575033f.jpg";